import { Dispatch, SetStateAction } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { IUserFromStorage } from '../../Interfaces/IUser';
import VideoPlayer from '../VideoPlayer/VideoPlayer';

import '../../Shared/css/TuProgreso/modalVideoProgreso.css';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const ModalVideoProgreso = ({ isOpen, setIsOpen }: Props) => {
  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));
  const isPG = user.objetivo !== 'MM';

  const videoUrl = isPG
    ? 'https://player.vimeo.com/external/1007811765.m3u8?s=83f657aeaacf780254cbbf975b0fad11b9c9aacc&logging=false'
    : 'https://player.vimeo.com/external/1007811259.m3u8?s=5c4ad5059489bb6b07db4ff297ec7981b27609e9&logging=false';

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          maxWidth: '480px',
          width: '100%',
          margin: '16px',
          boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
          overflow: 'hidden',
        },
      }}
    >
      {/* Custom Header */}
      <div className="mvm-header">
        <button className="mvm-back-btn" onClick={() => setIsOpen(false)}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="mvm-header-text">
          <span className="mvm-label">Video informativo</span>
          <h2 className="mvm-title">{isPG ? 'Perder Grasa' : 'Ganar Masa Muscular'}</h2>
        </div>
        <button className="mvm-close-btn" onClick={() => setIsOpen(false)}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <DialogContent sx={{ padding: 0 }}>
        {/* Video */}
        <div className="mvm-video-wrapper">
          <VideoPlayer url={videoUrl} />
        </div>

        {/* Tip */}
        <div className="mvm-tip">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" /><path d="M12 16v-4" /><path d="M12 8h.01" />
          </svg>
          <p>Este video te ayudará a entender cómo registrar tu progreso correctamente para obtener mejores resultados.</p>
        </div>

        {/* Close Button */}
        <div className="mvm-actions">
          <button className="mvm-done-btn" onClick={() => setIsOpen(false)}>
            Entendido
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ModalVideoProgreso;
